module.exports = __webpack_public_path__ + "img/loginPic.44780fdc.png";